import type { UseSearchQuotesParams } from './types';

export type UseSearchQuotesQueryKey = readonly [
  'search',
  'quotes',
  UseSearchQuotesParams,
];

export const getUseSearchQuotesQueryKey = (
  params: UseSearchQuotesParams,
): UseSearchQuotesQueryKey => ['search', 'quotes', params];
